<div
  [class.scrollable]="showScrollButton"
  class="iv-tabs-container"
>
  <button
    statistic
    statisticElementName="Click tab scroll button"
    (click)="scrollLeft(tabContainer);"
    *ngIf="showScrollButton"
    [class.disabled]="left === 0"
    class="scroll-button"
  >
    <span class="material-icons">&#xE314;</span>
  </button>

  <div
    #tabContainer
    class="tabs-container"
  >
    <div
      (cdkDropListDropped)="drop($event)"
      *ngIf="tabs.length > 0"
      [style.left.px]="left"
      cdkDropList
      cdkDropListOrientation="horizontal"
      class="iv-tabs"
    >
      <iv-live-tab
        (click)="onSelectTab(i, tab)"
        (saveTitle)="saveTitle()"
        (onCloseTab)="onCloseTab($event)"
        (onEditTitle)="onEditTitle($event)"
        *ngFor="let tab of tabs;
        index as i;"
        [tab]="tab"
        [index]="i"
        [closeable]="tabs.length > 1"
        [class.active]="tab.active"
        [class.iv-tab-chart-blink]="tab.type === 'chartService' && chartServiceBlink"
        [style.min-width.px]="(tabWidth)"
        [style.width.px]="(tabWidth)"
        cdkDrag
        [cdkDragDisabled]="isEditTitle"
        class="iv-tab"
        ></iv-live-tab>
    </div>
  </div>

  <button
    (click)="scrollRight(tabContainer);"
    *ngIf="showScrollButton"
    [class.disabled]="isRightArrowDisabled(tabContainer)"
    class="scroll-button"
  >
    <span class="material-icons">&#xE315;</span>
  </button>
</div>

<div class="new-tab-button-container">
  <button
    statistic
    statisticElementName="Click add new tab"
    (click)="onOpenNewTabClick()"
    class="iv-img-button new-tab-button"
    id="addNewTabButton"
  >
    <span class="material-icons">&#xE145;</span>
  </button>
</div>
